import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_ITEM_VOUCHER_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

/**
 * TODO: If other LOBs will make use of vouchers, view and controller will need
 * to be refactored to accomodate other products.
 *
 * Voucher URLs has backwards compatibility.
 * tripViewId = tripId
 * tripItemId = id
 *
 * /things-to-do/voucher/?tripid=f9b91928-79a1-5493-895e-0cf2bde56b38
 * /things-to-do/voucher/?tripid=f9b91928-79a1-5493-895e-0cf2bde56b38&id=5cbf9451-0ba2-4223-98f5-3b21996e177c_0_479307_479938
 * /things-to-do/voucher/?tripid=egti-B86-7C8-724C&id=OWRiZDkxNzEtOTA4Yy01MjM2LTlhY2QtZjM5OWIxZTU5MzlhO2VmMzc2YzkzLWU4ZjItNDQ0ZC1hZTFhLTI1N2VkYzJiMmEzNF8wXzI2OTExNF82NjkzOTU
 *
 */

export class TripItemVoucherController implements Controller {
  public readonly bundles = [];
  public readonly pageId = 'page.Trip.ItemVoucher,U,80';
  public readonly routeName = 'trip-item-voucher';
  public readonly exact = true;
  public readonly path = '/things-to-do/voucher/';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-item-voucher" */ 'views/trip-item-voucher-view')
  );
  public readonly pageName = 'page.Trip.ItemVoucher';
  public readonly clickstreamPageName = 'Trip Item Voucher';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_ITEM_VOUCHER_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-item-voucher-controller'
    });

    return Promise.resolve();
  }

  public shouldStreamResponse(): boolean {
    return false;
  }
}
